import { Clock } from "lucide-react";
import { useLanguage } from "@/lib/i18n";

interface TimelineItem {
  time: string;
  description: string;
}

interface ResultsTimelineSectionProps {
  items: TimelineItem[];
  title?: string;
}

export function ResultsTimelineSection({ items, title }: ResultsTimelineSectionProps) {
  const { t } = useLanguage();
  
  return (
    <section className="mb-8 md:mb-10">
      <h2 className="text-2xl md:text-3xl font-bold text-center mb-5 md:mb-7">
        {title || t('product.results')}
      </h2>
      <div className="bg-white/70 rounded-2xl md:rounded-3xl p-4 md:p-8 border border-white/80 shadow-sm">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
          {items.map((item, idx) => (
            <div key={idx} className="text-center">
              <div className="flex items-center justify-center gap-1 md:gap-2 mb-2 md:mb-3">
                <Clock className="w-4 h-4 md:w-5 md:h-5 text-primary" />
                <span className="font-bold text-sm md:text-lg">{item.time}</span>
              </div>
              <p className="text-xs md:text-sm text-muted-foreground leading-relaxed">{item.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
